import styled from 'styled-components';

const Line = styled.hr`
    // border-bottom: 2px solid black;
    // width: 20%;
    margin: auto 0;
    margin-right: 15px;
    width: 100%;
`;
function ProgressBarLine() {
    return (
        <Line />
    )
}

export default ProgressBarLine;